export default "__VITE_ASSET__Dg6cr59v__"